<template>
  <div>
    <div class="section-right-content-box">
      <div class="otherBtn">
        <el-button @click="statement" class="right-btn" plain
          >批量下载</el-button
        >
      </div>

      <!-- 导出管理 -->
      <subpage-title subpageTittle="导出管理"></subpage-title>
      <div class="table-box">
        <el-table
          label-position="left"
          :data="dataList"
          tooltip-effect="light"
          class="base-table"
          @selection-change="handleSelectionChange"
          :header-cell-style="{
            background: '#FAFAFA',
            color: '#3C4560',
          }"
          style="width: 100%; border: 1px solid #eee"
          v-loading="tableLoading"
        >
          <template slot="empty">
            <div>
              <img src="../../../assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column
            type="selection"
            align="left"
            width="55"
            :selectable="checkT"
          >
          </el-table-column>
          <el-table-column
            property="fileName"
            align="left"
            label="任务名称"
          ></el-table-column>
          <el-table-column
            property="type"
            align="left"
            label="导出类型"
          ></el-table-column>
          <el-table-column
            property="remark"
            align="left"
            label="备注"
          ></el-table-column>
          <el-table-column property="state" align="left" label="状态">
            <template slot-scope="scope">
              {{
                scope.row.state
                  ? scope.row.state == 1
                    ? "完成"
                    : "进行中"
                  : "失败"
              }}
            </template>
          </el-table-column>
          <el-table-column
            property="createTime"
            align="left"
            label="创建时间"
          ></el-table-column>
          <el-table-column label="操作" align="left">
            <template slot-scope="scope">
              <div class="btnCnt">
                <span
                  v-if="scope.row.state == 1"
                  @click="exportOne(scope.row)"
                  style="color: #364ecf"
                  >导出</span
                >
                <span
                  v-else
                  style="color: #ccc"
                  :class="{ disabled: isSpanDisabled }"
                  @mouseover="disableSpan"
                  @mouseleave="enableSpan"
                  >导出</span
                >
                <span @click="deleteOne(scope.row)" style="color: red"
                  >删除</span
                >
                <!--                               -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float: right; position: relative; top: 10px"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :current-page="pageInfo.current"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-size="pageInfo.size"
        >
        </el-pagination>
      </div>
    </div>
    <!--导出数据的短信验证-->
    <el-dialog
      title="身份验证"
      :visible.sync="sendDialog"
      width="460px"
      height="327px"
      style="min-width: 1200px; height: 800px"
    >
      <template slot="title">
        <span>身份验证</span>
      </template>
      <div class="export-dialog-wrapper" style="position: relative; top: -10px">
        <div
          class="sendHug"
          style="
            border-radius: 3px;
            height: 42px;
            line-height: 42px;
            width: 400px;
            background: #fafafa;
          "
        >
          <span
            class="font_family icon-gantanhao"
            style="margin-left: 2px; font-size: 10px; margin-right: 10px"
          ></span>
          <img
            src="@/assets/images/提示-红.svg"
            class="tips-icon"
            style="position: relative; top: 2px; margin-left: 1px"
          />
          <span
            class="font_family icon-gantanhao"
            style="margin-left: 8px; font-size: 10px; margin-right: 2px"
          ></span>
          <span style="font-size: 13px; color: #333333"
            >注：为了保护您的数据安全，导出数据需要手机验证。</span
          >
        </div>
        <div class="hug-send">
          <div class="send-left" style="line-height: 32px; margin-left: 10px">
            手机号：
          </div>
          <div class="send-right" style="display: flex">
            <input
              type="tel"
              class="codeBtn"
              v-model="mobile"
              placeholder=""
              :disabled="true"
              style
            />
            <span
              style="
                line-height: 32px;
                margin-left: 12px;
                font-size: 14px;
                color: #7f85e9;
                cursor: pointer;
              "
              @click="toChangePhone"
              >修改</span
            >
          </div>
        </div>
        <div class="hug-send">
          <div class="send-left" style="line-height: 32px; margin-left: 10px">
            验证码：
          </div>
          <div class="send-right send-right2">
            <input
              type="tel"
              class="codeBtn1"
              v-model="code"
              placeholder="请输入验证码"
              style="padding: 0 8px"
            />
            <el-button
              class="getNumber"
              v-model="codeMsg"
              @click="getCode"
              :disabled="codeDisabled"
              >{{ codeMsg }}</el-button
            >
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="sendDialog = false"
          size="small"
          style="width: 98px; color: #999999; margin: 0 4px 0 0"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="sureExport()"
          style="width: 98px; margin-left: 4px"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <!-- 绑定手机号码 -->
    <el-dialog
      title="绑定手机号码"
      :visible.sync="bindDialog"
      width="400px"
      style="min-width: 1200px"
    >
      <template slot="title">
        <span>绑定手机号码</span>
      </template>
      <div class="export-dialog-wrapper">
        <span>为了保护您的数据安全，导出前需绑定手机号码~</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="onceJump"
          style="width: 100px"
          >立即前往</el-button
        >
        <el-button @click="bindDialog = false" size="small" style="width: 100px"
          >取消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import {
  queryExportFileRecord,
  delectExportFileRecord,
  batchExport,
  getSellerExport,
  deleteSellerExport,
  querySellerSetting,
  sendSmsSellerCode,
  ExportFile,
} from "@/api/backstage/exportmanage";
// 验证码
import { sendSmsVerifyCode } from "@/api/public";
// 首页 买家信息 短信软件剩余天数
import { getSoftwareInfo } from "@/api/home";
// 导出弹窗
import subpageTitle from "@/components/subpage-title.vue";
export default {
  name: "export-management",
  components: { subpageTitle },
  computed: {
    ...mapState({
      changeColor: "globalBG1",
    }),
  },
  data() {
    return {
      flag: false,
      mobile: "",
      isSpanDisabled: false,
      // 表单loading
      tableLoading: false,
      mobile: "",
      // 删除弹窗
      deleteDialog: true,
      pageInfo: {
        total: 0,
        current: 1,
        size: 10,
      },
      dataList: [],
      phone: "", //用户的手机号
      code: "", //验证码
      codeMsg: "获取验证码", //按钮上的文字
      codeDisabled: false, //按钮可点击？（是否绑定手机）
      timer: null, //验证码定时器
      countdown: 60, // 倒计时秒数
      successMsg: "",
      sendDialog: false, //短信验证弹窗
      bindDialog: false, // 绑定手机号码弹窗
      multipleSelection: [],
      singRecord: null,
      timeIdx: "",
      isOpenDownload:''
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, "导出管理", "后台管理", "导出管理");
  },
  mounted() {
    this.queryData();
  },
  methods: {
    disableSpan() {
      this.isSpanDisabled = true;
    },
    enableSpan() {
      this.isSpanDisabled = false;
    },
    // 将回传的列表数据显示为已勾选-根据状态是否完成
    checkT(row, index) {
      if (row.state == 0 || row.state == -1) {
        return false;
      } else {
        return true;
      }
    },
    // 1.获取导出管理列表
    queryData() {
      this.tableLoading = true;
      getSellerExport({
        size: this.pageInfo.size,
        current: this.pageInfo.current
      }).then((res) => {
        if (res.code == 1) {
          this.dataList = res.data.records;
          this.pageInfo.total = res.data.total;
        }
        this.tableLoading = false;
      });
    },
    // 2.列表分页
    handleSizeChange(val) {
      this.pageInfo.current = 1;
      this.pageInfo.size = val;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.pageInfo.current = val;
      this.queryData();
    },
    // 3.删除按钮
    deleteOne(row) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteSellerExport([row.id]).then((res) => {
            if (res.code == 1) {
              this.$message.success("删除成功!");
              this.queryData();
            }
          });
        })
        .catch(() => {});
    },
    // 4.导出按钮
    exportOne(row) {
      console.log(row, "8888888888");
      this.code = "";
      this.codeMsg = "获取验证码";
      this.timer = null;
      this.codeDisabled = false;
      this.singRecord = row;
      this.successMsg = "";
      // 获取当前登录账号信息
      // 判断是否绑有手机号
      querySellerSetting({
        Accept: "*/*",
      }).then((res) => {
        if(res.data.code==0){
          this.$message.error(res.data.message)
          return
        }
        console.log(res, "判断是否绑有手机号");
        this.mobile = res.data.sellerVO.mobile;
        this.isOpenDownload = res.data.tbPhoneBindingVO.isOpenDownloadRemind;
        if (this.isOpenDownload === 1) {
          this.sureExport();
        } else {
          //  如果绑定了手机号码，打开短信验证弹窗
          if (this.mobile !== "" && this.mobile !== null) {
            this.sendDialog = true;
          } else {
            // 如果没有绑定，打开绑定手机号码弹窗，前往绑定
            this.bindDialog = true;
          }
        }
      }).catch((res)=>{});
    },
    // 5.前往绑定手机号码
    onceJump() {
      window.open("/backstage/account/account", "_self");
    },
    // 6.修改手机号
    toChangePhone() {
      //跳转到帐号设置绑定手机
      window.open("/backstage/account/account", "_self");
    },
    // 6.获取验证码
    getCode() {
      let params = { mobile: this.mobile };
      let _that = this;
      _that.codeDisabled = true;
      if (_that.codeMsg !== "获取验证码") return;
      //1.获取验证码做手机号码判断
      sendSmsSellerCode(params)
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.error(res.data.message);
          }
        })
        .catch((e) => {});
      let clock = window.setInterval(() => {
        _that.countdown--;
        _that.codeMsg = "重新发送(" + _that.countdown + ")";
        if (_that.countdown === 0) {
          window.clearInterval(clock);
          _that.countdown = 60;
          _that.codeMsg = "获取验证码";
          _that.codeDisabled = false;
        }
      }, 1000);
      this.timeIdx = clock;
    },
    // 7.身份验证-确认导出
    sureExport() {
      // 验证后导出数据
      if (this.code == "" && (this.isOpenDownload == null || this.isOpenDownload != 1 )) {
        this.$message.info("请输入验证码");
        return;
      }
      let ids = "";
      if (this.singRecord) {
        ids = [this.singRecord.id];
      } else {
        let smsBatchIds = [];
        this.multipleSelection.forEach((item) => {
          smsBatchIds.push(item.id);
        });
        ids = smsBatchIds;
      }
      //清空定时器
      window.clearInterval(this.timeIdx);
      this.countdown = 60;
      this.codeMsg = "获取验证码";
      this.codeDisabled = false;
      let params = {
        idList: ids,
        code: this.code,
      };
      ExportFile({
        ...params,
      })
        .then((res) => {
          if (res.code == 0) {
            this.$message.error(res.message);
            return;
          }
          console.log(res, "导出数据");
          let blob = new Blob([res.blob]);
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          // 获取本地时间
          const currentDate = new Date();
          // 修改时间格式
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, "0");
          const day = String(currentDate.getDate()).padStart(2, "0");
          const hours = String(currentDate.getHours()).padStart(2, "0");
          const minutes = String(currentDate.getMinutes()).padStart(2, "0");
          const seconds = String(currentDate.getSeconds()).padStart(2, "0");
          // const formattedDate = currentDate.toISOString().replace(/[-:]/g, '_');
          const formattedDate = `${year}-${month}-${day} ${hours}_${minutes}_${seconds}`;
          console.log(blob, href, "测试");
          downloadElement.href = href;
          if (this.singRecord) {
            downloadElement.download = this.singRecord.fileName; //下载后文件名
          } else if (this.multipleSelection.length == 1) {
            downloadElement.download = this.multipleSelection[0].fileName; //下载后文件名
          } else {
            downloadElement.download = `导出文件-${formattedDate}.zip`; //下载后文件名
          }

          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          console.log(err);
        });
      this.sendDialog = false;
    },
    // 8.多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 9.点击批量下载
    statement() {
      this.codeMsg = "获取验证码";
      this.timer = null;
      this.codeDisabled = false;
      this.successMsg = "";
      this.code = "";
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请勾选报表数据");
      } else {
        this.singRecord = null;
        // 判断是否绑有手机号
        querySellerSetting({
          Accept: "*/*",
        }).then((res) => {
          if(res.data.code==0){
            this.$message.error(res.data.message)
            return
          }
          console.log(res, "判断是否绑有手机号");
          this.mobile = res.data.sellerVO.mobile;
          this.isOpenDownload = res.data.tbPhoneBindingVO.isOpenDownloadRemind;
        if (this.isOpenDownload === 1) {
          this.sureExport();
        } else {
          //  如果绑定了手机号码，打开短信验证弹窗
          if (this.mobile !== "" && this.mobile !== null) {
            this.sendDialog = true;
          } else {
            // 如果没有绑定，打开绑定手机号码弹窗，前往绑定
            this.bindDialog = true;
          }
        }
        });
      }
    },
  },
};
</script>

<style>
input::input-placeholder {
  color: #cccccc;
}
input::-webkit-input-placeholder {
  color: #cccccc;
}
</style>

<style lang="scss" scoped>
.disabled {
  // opacity: 0.5;
  cursor: not-allowed;
}
/deep/ .el-dialog__header {
  height: 54px;
  line-height: 54px;
}
.right-btn {
  width: 76px;
  height: 32px;
  opacity: 1;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  float: right;
}
/* 导出数据模态框 */
.sendHug {
  width: 345px;
  height: 30px;
  background: rgba(255, 118, 0, 0.1);
  margin-left: 10px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 118, 0, 1);
}

.hug-send {
  overflow: hidden;
  margin-top: 20px;

  .send-left {
    float: left;
    height: 20px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 20px;
    color: rgba(102, 102, 102, 1);
    margin-left: 50px;
  }

  .send-right {
    float: left;
    font-size: 15px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 21px;
    color: #333333;
  }

  .send-right2 {
    display: flex;
    height: 32px;
  }

  .codeBtn {
    width: 304px;
    height: 32px;
    display: inline-block;
    line-height: 26px;
    font-size: 15px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #ccc;
    outline-style: none;
    float: left;
    background: #fffffff;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #dddddd;
  }

  .codeBtn1 {
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 110px;
    display: inline-block;
    line-height: 26px;
    font-size: 15px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #666;
    outline-style: none;
    float: left;
    width: 230px;
    height: 32px;
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid #dddddd;
  }

  .getNumber {
    width: 100px;
    line-height: 26px;
    margin-left: 12px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #fe4d45;
    color: #fe4d45;
  }

  .msg {
    font-size: 10px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 14px;
    color: rgba(153, 153, 153, 1);
    text-align: center;
  }
}
.section-right-content-box {
  background-color: #fff;
  /*box-shadow: 0 8px 20px rgba(139, 156, 188, 0.16);*/
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  padding: 30px 24px 55px 24px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 10px 20px 20px 20px;
  .btnCnt {
    & > span {
      cursor: pointer;
    }
    & > span:not(:first-child) {
      margin-left: 15px;
    }
  }
}
</style>
